import withErrorBoundary from '../ErrorBoundary';
import { UI_PURCHASE_MOTION_BUTTON } from '../_core/common/constants/ErrorBoundaryNames';
import PurchaseMotionButton from '../_core/purchaseMotions/PurchaseMotionButton';
export default withErrorBoundary(PurchaseMotionButton, {
  boundaryName: UI_PURCHASE_MOTION_BUTTON
});